<template>
  <b-row class="wrap-dec">
    <b-col
      cols="12"
      md="6"
      class="left"
    >
      <div class="box"></div>
      <p>{{ name }}</p>
    </b-col>
    <b-col
      cols="12"
      md="6"
      class="right"
    >
      <p><span>:</span> {{ data }}</p>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    name: String,
    data: String
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-dec {
  .left {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .box {
      width: 15px;
      height: 15px;
      background-color: $active;
    }

    p {
      margin: 4px 0 0 12px;
      font-size: 1.75rem;
    }
  }

  .right {
    p {
      padding-left: 28px;
      font-size: 1.75rem;

      span {
        display: none;

        @media only screen and (min-width: $break-m) {
          display: inline-block;
        }
      }
    }
  }
}
</style>
